import React from 'react'

import { useTranslation } from 'react-i18next'

import AlertCard from '@components/myScores/MessagesView/AlertCard'
import { formatDate } from '@utils/formatters/date.formatter'
import { formatPriceInCents } from '@utils/formatters/number.formatter'

import type AccountAlert from '@models/AccountAlert'

interface Props {
  alert: AccountAlert
}

const RefundConfirmationAccountAlert: React.FC<Props> = ({ alert }) => {
  const { t } = useTranslation()
  return (
    <AlertCard alert={alert}>
      <p className="text-lg mb-2.5">{t('content.refundSent')}</p>
      <p className="mb-2.5">
        {t('content.refundedAmount', {
          amount: formatPriceInCents(alert.amount ?? 0),
          date: formatDate(alert.date),
        })}
      </p>
    </AlertCard>
  )
}

export default RefundConfirmationAccountAlert
